import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { CreditAllocationStatus } from "gen/txn/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { QueryParams, WebUrl } from "shared-web/lib/webUrl"

import { CREDITS_TABLE_STATUS_FILTER_KEY } from "features/pos/receivables/CreditsSearch/table"

const BASE_CREDITS_PATH = "/pos/receivables/credits"

export function credits(statuses?: CreditAllocationStatus[]): WebUrl {
  const pathname = BASE_CREDITS_PATH

  if (!statuses || statuses.length === 0) {
    return { pathname }
  }

  const query: QueryParams = {
    [CREDITS_TABLE_STATUS_FILTER_KEY]: statuses.map((status) =>
      status.toString()
    ),
  }

  return { pathname, query }
}

export function credit(id?: PBUUID): WebUrl {
  return {
    pathname: `${BASE_CREDITS_PATH}/${UUID.idString(id)}`,
  }
}
